export const testAttributes = {
    HOW_TO_CONTAINER: 'how_to_container',
    HOW_TO_LIST_CONTAINER: 'how_to_list_container'
}

export const listType = 'orderedList';